import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';

const BSLASandSkinkAreaLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        url: 'https://utility.arcgis.com/usrsvcs/servers/e53ddb3e5376411caa292f4e5f7559c0/rest/services/BATS_SKINKS_V2/FeatureServer/1',
        visible: false,
        title: 'Sand Skink Consultation Area',
        popupTemplate: {
            outFields: ['*'],
            title: 'Sand Skink Consultation Area',
            content: (feature: __esri.Feature) => {
                const node = document.createElement('div');

                const content = (
                    <React.Fragment>
                        <div className="mb-1">
                            <p className="mb-1">
                                Sand skinks (<i>Neoseps reynoldsi</i>) and bluetail mole skinks (Eumeces egregius lividus) are found in interior peninsular Florida. Both species
                                are most commonly associated with habitat dominated by xeric vegetation such as oak-dominated scrub, turkey oak barrens, high pine, and xeric
                                hammocks. Skinks typically occur in habitats that contain a mosaic of open sandy patches interspersed with forbs, shrubs. and trees. Although sand
                                skink tracks are most typically observed in open sandy areas, both species utilize a variety of other micro-habitats within xeric vegetative
                                communities. Areas containing extensive rooted vegetation within this matrix may preclude sand skink movement and are less likely to be used by
                                skinks. They appear to be most abundant in the ecotone between areas with abundant leaf litter and vegetative cover and adjacent open sands.
                                Suitable bluetail mole skink habitat is restricted to xeric uplands within the Lake Wales Ridge in Highlands, Osceola, and Polk counties. Sand skink
                                habitat occurs within the Lake Wales Ridge but is also found on the Winter Haven Ridge in Polk County and the Mount Dora Ridge in Lake. Marion,
                                Orange, and Putnam counties.
                            </p>
                            <p className="mb-1">
                                Determining their presence or absence can be very costly due to survey requirements. Two types of surveys are recommended for determining if skinks
                                are present. The pedestrian survey, which is the least labor intensive protocol, is a meandering walking survey through suitable habitat and can
                                determine presence, but not absence of skinks. The cover board survey is more labor intensive, season specific, and required to support a final
                                determination that skinks are presumed absent. Boards with sand on them are placed periodically over a parcel and are checked regularly. Mitigation
                                cost are approximately $30,000 per acre if Skinks are found.
                            </p>
                            <p>Hire a qualified specialist if this layer is showing on a property you are about to purchase.</p>
                        </div>
                        <BSLAExternalLinkComponent href="https://www.fws.gov/northflorida/Skink/skinks.htm" />
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLASandSkinkAreaLayer;
